let queneUrl = process.env.VUE_APP_QUEUE_API;
let apiUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_TM;
let captchaUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_CAPTCHA;

import { decrypt, encrypt } from "@/vendor/crypto";

class TM {
  static generateOTP() {
    return axios.post(`${captchaUrl}/generateOTP`, {});
  }

  static generateCaptcha(sid, refresh) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    let params = {
      sessionId: decrypt(sid)
    };
    if (refresh) params.refresh = true;
    return axios.post(`${captchaUrl}/generate`, params, {
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${token}`
      }
    });
  }

  static getShippingFee(orderId) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(
      `${apiUrl}/getShippingFee`,
      { orderId },
      {
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    );
  }

  static getUserCurrentReservedOrder() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getUserCurrentReservedOrder`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static getSeatsByTicketAreaId(ticketAreaId) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(
      `${apiUrl}/getSeatsByTicketAreaId?ticketAreaId=${ticketAreaId}`,
      {
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    );
  }

  static ticketEnqueue(products, abort) {
    if (!window.isEnquene) return false;
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios
      .post(`${queneUrl}/enqueue`, products, {
        withCredentials: true,
        signal: abort.signal,
        headers: {
          authorization: `Bearer ${token}`
        }
      })
      .catch(error => {
        return {
          data: { errCode: "999" }
        };
      });
  }

  static ticketReserve(products) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios
      .post(`${apiUrl}/reserve`, products, {
        headers: {
          authorization: `Bearer ${token}`
        }
      })
      .catch(error => {
        return {
          data: { errCode: "999" }
        };
      });
  }

  static ticketRelease(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/release`, params, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }
  static ticketUpdate(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios
      .post(`${apiUrl}/update`, params, {
        headers: {
          authorization: `Bearer ${token}`
        }
      })
      .catch(error => {
        return {
          data: { errCode: "999" }
        };
      });
  }
  static ticketConfirm(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios
      .post(`${apiUrl}/confirm`, params, {
        headers: {
          authorization: `Bearer ${token}`
        }
      })
      .catch(error => {
        return {
          data: { errCode: "999" }
        };
      });
  }
  static getOrderStatus(orderId, abort) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getOrderStatus?orderId=${orderId}`, {
      signal: abort.signal,
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }
  static updateApplicants(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/updateApplicants`, params, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }
}

export default TM;
